import { render, staticRenderFns } from "./WorkEditTabInformation.vue?vue&type=template&id=4ca95dbf&"
import script from "./WorkEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./WorkEditTabInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports